import React, { PureComponent } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { login, logout } from '../../store/actions';
import { logException } from '../../services/utils';
import qs from 'qs';
import PropTypes from 'prop-types';
import * as analytics from '../../services/analytics';

const propTypes = {
  login: PropTypes.func,
};

class AuthView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isTokenValidated: null,
    };
  }

  componentDidMount() {
    const { location, login, logout } = this.props;
    const query = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    analytics.track('Broker Portal - Broker Auth Token Submitted', {
      noninteraction: 1,
    });
    login(query.token)
      .then(() => {
        analytics.track('Broker Portal - Broker Auth Token Validated', {
          noninteraction: 1,
        });
        this.setState({
          isTokenValidated: true,
        });
      })
      .catch((error) => {
        analytics.track('Broker Portal - Broker Auth Token Invalid', {
          noninteraction: 1,
        });
        logout();
        this.setState({
          isTokenValidated: false,
        });
        logException(error);
      });
  }

  render() {
    switch (this.state.isTokenValidated) {
      case true:
        return <Redirect to="/dashboard" />;
      case false:
        return <Redirect to="/login?error=invalid_token" />;
      default:
        return null;
    }
  }
}

AuthView.propTypes = propTypes;

const mapStateToProps = (state) => ({
  authToken: state.authToken,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      login,
      logout,
    },
    dispatch
  );

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(AuthView);
